module.exports = __webpack_public_path__ + "media/images/mental-health-dbefd3cff8acbb03f55ca906776071b5.svg";